export default __webpack_public_path__ + "static/media/web-abouth265.3e8c0f5a.mp4";